import { checkStatus, handleError } from '../../utils/api';
import { AffiliationEligibilityDetail } from '../../interfaces/register';
import apiFetch from '../core/apiFetch';
import { getAuthTokenAsync } from '../../utils/authToken';

const getAffiliationEligibilityDetailsAsync = async (
  affiliationId: number
): Promise<{ affiliationEligibilityDetail?: AffiliationEligibilityDetail }> => {
  const authToken = await getAuthTokenAsync();
  const url = `api/v1/affiliation_eligibility_details/${affiliationId}`;

  try {
    const response = await apiFetch(authToken, url, { method: 'GET' });
    await checkStatus(response);

    const affiliationEligibilityDetail = await response.json();

    return {
      affiliationEligibilityDetail: {
        tooltipImage: affiliationEligibilityDetail.tooltip_image,
        insuranceLabel: affiliationEligibilityDetail.insurance_label,
        notAllowedFamilyMembersText:
          affiliationEligibilityDetail.not_allowed_family_members_text,
      },
    };
  } catch (error) {
    handleError('unexpected status - search affiliation coverage', error);
    return { affiliationEligibilityDetail: undefined };
  }
};

export default getAffiliationEligibilityDetailsAsync;
